/**
 * Ryan O'Dowd
 * 2024-12-07
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({colors, globalScale}) => {
  return {
    filterButton: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minWidth: globalScale * 28,
      padding: 0,
      backgroundColor: colors.primaryLight,
      borderWidth: globalScale * 2,
      borderColor: colors.primaryDark,
      borderRadius: globalScale * 8,
    },
    filterButtonSelected: {
      backgroundColor: colors.accent,
      borderColor: colors.accentDark,
    },
    filterLabel: {
      margin: globalScale * 4,
      color: colors.primaryDark,
    },
    filterLabelSelected: {
      color: colors.primaryExtraDark,
    },
  };
};

export default getStyles;
